import axios from 'axios'

const origin = process.env.VUE_APP_API_ORIGIN
const get = path => axios.get(origin + path).then(response => response.data)
const post = (path, payload) => axios.post(origin + path, payload).then(response => response.data)

const hasOwn = (item, key) => Boolean(item) && Object.prototype.hasOwnProperty.call(item, key)

const hasAnyField = (item, ...keys) => keys.some(key => {
  return hasOwn(item, key) || hasOwn(item, key.toUpperCase())
})

const contractMismatchError = detail => {
  const error = new Error(
    '権限情報を取得できませんでした。' +
    'システムの更新中か、更新直後の可能性があります。' +
    '時間をおいて画面を再読み込みしてください。解消しない場合は、表示されている内容を添えて社内の管理者へご連絡ください。' +
    (detail ? `（${detail}）` : '')
  )
  error.code = 'TENANT_PERMISSION_API_CONTRACT_MISMATCH'
  return error
}

/**
 * 契約プラン連動後のPermission API応答であることを確認する。
 *
 * 旧バックエンドはfeature_enabled等を返さない。欠落値をfalseへ暗黙変換すると、
 * PREMIUM企業でも全Permissionを「契約対象外」と誤表示するため、表示前に停止する。
 */
export const validateTenantPermissionResponse = data => {
  if (!Array.isArray(data)) {
    throw contractMismatchError('利用できる機能の一覧を読み取れませんでした')
  }
  if (!data.length) {
    throw contractMismatchError('利用できる機能を確認できませんでした')
  }

  const requiredFields = [
    ['featureEnabled', 'feature_enabled'],
    ['featureSource', 'feature_source'],
    ['planCode', 'plan_code'],
    ['planName', 'plan_name']
  ]

  const invalid = data.some(item => requiredFields.some(keys => !hasAnyField(item, ...keys)))
  if (invalid) {
    throw contractMismatchError('契約プランの情報を確認できませんでした')
  }

  return data
}

export default {
  getRoles () { return get('/tenant-access-management/roles') },
  getPermissions () {
    return get('/tenant-access-management/permissions')
      .then(validateTenantPermissionResponse)
  },
  getUsers () { return get('/tenant-access-management/users') },
  createRole (payload) { return post('/tenant-access-management/role', payload) },
  replaceRolePermissions (payload) { return post('/tenant-access-management/role/permissions', payload) },
  assignRole (payload) { return post('/tenant-access-management/user-role/assign', payload) },
  removeRole (payload) { return post('/tenant-access-management/user-role/remove', payload) },
  getOwnerUsers () { return get('/tenant-access-management/owner-users') },
  getOwnerInvitations () { return get('/tenant-access-management/owner-invitations') },
  inviteOwner (payload) { return post('/tenant-access-management/owner-invitations', payload) },
  resendOwnerInvitation (invitationId) {
    return post(`/tenant-access-management/owner-invitations/${invitationId}/resend`, {})
  },
  revokeOwnerInvitation (invitationId) {
    return post(`/tenant-access-management/owner-invitations/${invitationId}/revoke`, {})
  },
  acceptExistingOwnerInvitation (payload) {
    return post('/tenant-access-management/owner-invitations/accept-existing', payload)
  },
  removeOwner (userId, payload) {
    return post(`/tenant-access-management/owners/${userId}/remove`, payload)
  }
}
